var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaveee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1800,
    height: 700,
    viewBox: "469 60 792 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8038"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 755",
    opacity: 0.8,
    cx: 1748,
    cy: 52,
    r: 52,
    fill: "#009967"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8037"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 761",
    cx: 1599.5,
    cy: 201.5,
    r: 71.5,
    fill: "#CCE5EB",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 784",
    cx: 643.5,
    cy: 221.5,
    r: 71.5,
    fill: "#005466",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M1 484V195.148C1 195.148 206 147.006 418 225.149C630 303.293 754 154.68 910 174.914C1066 195.148 1086 320.038 1306 247.476C1526 174.914 1730 195.148 1730 195.148V484H1Z",
    fill: "#007E99",
    stroke: "#00191F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 754",
    cx: 513,
    cy: 144,
    r: 24,
    fill: "#CCEBE1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 783",
    cx: 1411,
    cy: 152,
    r: 24,
    fill: "#CCEBE1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 760",
    cx: 1061,
    cy: 144,
    r: 24,
    fill: "#55A9BB",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 757",
    cx: 827,
    cy: 120,
    r: 38,
    fill: "#009967",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 759",
    cx: 325,
    cy: 130,
    r: 38,
    fill: "#55A9BB",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 756",
    cx: 1227,
    cy: 222,
    r: 38,
    fill: "#CCE5EB"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 758",
    cx: 22,
    cy: 129,
    r: 21,
    fill: "#2B94AA"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 770",
    cx: 222,
    cy: 470,
    r: 141,
    fill: "url(#paint0_linear_1493_45123)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 777",
    cx: 707.5,
    cy: 334.5,
    r: 61.5,
    fill: "url(#paint1_linear_1493_45123)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 778",
    cx: 506.5,
    cy: 446.5,
    r: 30.5,
    fill: "url(#paint2_linear_1493_45123)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 781",
    cx: 1189.5,
    cy: 323.5,
    r: 30.5,
    fill: "url(#paint3_linear_1493_45123)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 776",
    cx: 395.5,
    cy: 275,
    rx: 44.5,
    ry: 40,
    fill: "url(#paint4_linear_1493_45123)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 775",
    cx: 134.5,
    cy: 235.5,
    rx: 30.5,
    ry: 27.5,
    fill: "url(#paint5_linear_1493_45123)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 774",
    cx: 1463.5,
    cy: 292.5,
    r: 61.5,
    fill: "url(#paint6_linear_1493_45123)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 773",
    cx: 984,
    cy: 249,
    r: 41,
    fill: "url(#paint7_linear_1493_45123)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 779",
    cx: 899,
    cy: 429,
    r: 41,
    fill: "url(#paint8_linear_1493_45123)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 780",
    cx: 1463,
    cy: 406,
    r: 41,
    fill: "url(#paint9_linear_1493_45123)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 772",
    cx: 1215.5,
    cy: 513.5,
    r: 93.5,
    fill: "url(#paint10_linear_1493_45123)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 772_2",
    cx: 1692.5,
    cy: 462.5,
    r: 75.5,
    fill: "url(#paint11_linear_1493_45123)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1493_45123",
    x1: 222,
    y1: 329,
    x2: 222,
    y2: 499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1493_45123",
    x1: 707.5,
    y1: 273,
    x2: 707.5,
    y2: 347.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1493_45123",
    x1: 506.5,
    y1: 416,
    x2: 506.5,
    y2: 452.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1493_45123",
    x1: 1189.5,
    y1: 293,
    x2: 1189.5,
    y2: 329.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1493_45123",
    x1: 395.5,
    y1: 235,
    x2: 395.5,
    y2: 283.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1493_45123",
    x1: 134.5,
    y1: 208,
    x2: 134.5,
    y2: 241.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1493_45123",
    x1: 1463.5,
    y1: 231,
    x2: 1463.5,
    y2: 305.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1493_45123",
    x1: 984,
    y1: 208,
    x2: 984,
    y2: 257.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1493_45123",
    x1: 899,
    y1: 388,
    x2: 899,
    y2: 437.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1493_45123",
    x1: 1463,
    y1: 365,
    x2: 1463,
    y2: 414.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1493_45123",
    x1: 1215.5,
    y1: 420,
    x2: 1215.5,
    y2: 532.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1493_45123",
    x1: 1692.5,
    y1: 387,
    x2: 1692.5,
    y2: 478.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveee);
export default __webpack_public_path__ + "static/media/waveee.e927365d771e5342a9ef6ef4c88832c2.svg";
export { ForwardRef as ReactComponent };